import { moduleDocument, runDocument, stackDocument } from "./documents";

const Initialization = `package spacelift

# 🦕 Feel free to remove commented code once your policy is ready. 🦕
#
# ⚠️ Initialization policies only take effect once attached to a Stack or Module ⚠️
#
# Initialization policy can prevent a run from being initialized, thus blocking
# any custom code or commands from being executed. As input, it
# receives a JSON document like this:
#
# {
#   "commit": {
#     "author": "string",
#     "branch": "string",
#     "created_at": "number (timestamp in nanoseconds)",
#     "message": "string"
#   },
#   "request": {
#     "timestamp_ns": "number - current Unix timestamp in nanoseconds"
#   },
#   "run": {
${runDocument(5)}
#   },
#   "stack": {
${stackDocument(5)}
#   },
#   "stack": {
${moduleDocument(5)}
#   }
# }
#
# The policy may then define one or more "deny" rules along with a message, to
# prevent unwanted runs from being executed. Each "deny" rule will print out its
# message to user-facing log so please keep these civil and informative. Below
# are a few examples of what you can do.
#
# 1) Only allow some whitelisted commands to be executed before initialization:
# deny contains sprintf("before_init command not whitelisted (%s)", [command]) if {
#   whitelisted := {"terraform fmt -check"}
#   command := input.run.runtime_config.before_init[_]
#
#   not whitelisted contains command
# }
#
# 2) Prevent minor Terraform version bumps, while allowing patch changes:
# stackTF := input.stack.terraform_version
# runTF := input.run.runtime_config.terraform_version
#
# deny contains msg if {
#   stackTF != null
#   msg := sprintf("must not skip a patch Terraform version (%s vs. %s)", [stackTF, runTF])
#
#   tfSemverDiff("patch") > 1
# }
#
# tfSemverDiff(key) = ret if {
#   runVersion := semver(runTF)
#   stackVersion := semver(stackTF)
#
#   ret := runVersion[key] - stackVersion[key]
# }
#
# semver(string) = ret if {
#   parts := [part | strParts := split(string, ".")
#                    part := to_number(strParts[_])]
#   ret := { "major": parts[0], "minor": parts[1], "patch": parts[2] }
# }
#
# 3) Don't run anything on weekends:
# deny contains "must not run anything on weekends" if {
#   today := time.weekday(input.request.timestamp_ns)
#   weekend := {"Saturday", "Sunday"}
#
#   weekend contains today
# }
#
# Now go ahead and unleash your inner lawgiver. For more information on the rule
# language, please visit https://www.openpolicyagent.org/docs/latest/
#
# NOTE:
# We prepend some boilerplate code to the policy to ensure that the outputs
# are defined. You can't change the type of our predefined rules (e.g. deny,
# flag, sample) or you'll run into conflicting rule errors.
# For a detailed example and further explanation, refer to our documentation:
# https://docs.spacelift.io/concepts/policy#policy-structure
`;

export default Initialization;
